import { Token } from './../models/token';

import { TokenUtils } from './token.util';
import { Marina} from '../models';
import { MarinaCompany } from '../models/marina-company';

export class StorageUtil {
  constructor() {}

  public static updateMovementExecutionInteractions(movementInteractList: number[], movementLastInteract: number): void {
    localStorage.setItem('movementInteractList', JSON.stringify(movementInteractList));
    if(movementLastInteract) {
      localStorage.setItem('movementLastInteract', JSON.stringify(movementLastInteract));
    } else {
      localStorage.removeItem('movementLastInteract');
    }
  }

  public static getMovementInteractList(): number[] {
    if (localStorage.getItem('movementInteractList')) {
      return JSON.parse(localStorage.getItem('movementInteractList'));
    }

    return [];
  }

  public static getMovementLastInteract(): number {
    if (localStorage.getItem('movementLastInteract')) {
      return JSON.parse(localStorage.getItem('movementLastInteract'));
    }

    return undefined;
  }

  public static getMarina(): Marina {
    let currentMarina: any = {};
    if (localStorage.getItem('currentMarina')) {
      currentMarina = JSON.parse(localStorage.getItem('currentMarina'));
      return currentMarina != null
        ? (currentMarina as Marina)
        : null;
    } else {
      this.logout();
      window.location.reload();
    }
  }

  public static setMarina(marina: Marina): void {
    localStorage.setItem('currentMarina', JSON.stringify(marina));
  }

  public static getMarinaId(): number {
    if (localStorage.getItem('currentMarina') != null){
      const currentId = this.getMarina().id;
      if (currentId) {
        return currentId;
      }
    }
    const tokenMarinasIdsAccess = this.getDecodeToken().marinasIdsAccess;
    if ( tokenMarinasIdsAccess && tokenMarinasIdsAccess != null
    && tokenMarinasIdsAccess.length > 0) {
      return tokenMarinasIdsAccess[0];
    }
    return null;
  }

  public static getMarinaName(): string {
    const currentMarina = this.getMarina();
    if (currentMarina) {
      return currentMarina.tradeName;
    }
    return '';
  }

  public static getUserName(): string {
    const tokenObj = this.getDecodeToken();
    if (tokenObj) {
      return tokenObj.firstName + ' ' + tokenObj.lastName;
    }
    return '';
  }

  public static getUserId(): number {
    const currentUserId = this.getDecodeToken().userId;
    if (currentUserId) {
      return currentUserId;
    }
  }

  // Preferência do menu lateral (recolhido/expandido), por usuário (EAS-249).
  private static readonly SIDENAV_PREF_PREFIX = 'sidenavOpened_';

  public static setSidenavOpened(opened: boolean): void {
    try {
      const userId = this.getUserId();
      if (userId == null) { return; }
      localStorage.setItem(`${this.SIDENAV_PREF_PREFIX}${userId}`, JSON.stringify(opened));
    } catch { /* preferência é não-crítica; ignora falhas */ }
  }

  // Retorna a preferência salva do usuário, ou null se nunca foi definida.
  public static getSidenavOpened(): boolean | null {
    try {
      const userId = this.getUserId();
      if (userId == null) { return null; }
      const stored = localStorage.getItem(`${this.SIDENAV_PREF_PREFIX}${userId}`);
      return stored != null ? JSON.parse(stored) : null;
    } catch { return null; }
  }

  public static getLogoMarina(): string {
    const currentMarina = this.getMarina();
    if (currentMarina) {
      return currentMarina.logoFile;
    }
    return null;
  }

  public static getUser(): Token {
    const user = this.getDecodeToken();
    return user;
  }

  public static getMarinasIds(): number[] {
    return this.getDecodeToken().marinasIdsAccess;
  }

  public static getMarinaCompanies(): MarinaCompany[] {
    const marinaCompanies = this.getMarina().marinaCompanies;
    if (marinaCompanies) {
      return marinaCompanies;
    }
    return null;
  }

  public static setLastPayment(vencimento: string): void {
    sessionStorage.setItem('vencimento', vencimento);
  }

  public static getLastPayment(): string {
    return sessionStorage.getItem('vencimento');
  }

  public static logout(): void {
    // Preserva a preferência do menu lateral entre sessões (EAS-249),
    // pois o clear() abaixo apagaria a chave por usuário.
    const sidenavPrefs: { [key: string]: string } = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(this.SIDENAV_PREF_PREFIX)) {
        sidenavPrefs[key] = localStorage.getItem(key);
      }
    }
    sessionStorage.clear();
    localStorage.clear();
    Object.keys(sidenavPrefs).forEach((key) => localStorage.setItem(key, sidenavPrefs[key]));
  }

  public static login(token: string, refreshToken: string, marina: Marina): void {
    this.saveToken(token);
    this.saveRefreshToken(refreshToken);
    localStorage.setItem('currentMarina', JSON.stringify(marina));
  }

  public static saveToken(token: string): void {
    localStorage.setItem('token', token);
  }

  public static saveRefreshToken(refreshToken: string): void {
    localStorage.setItem('refreshToken', refreshToken);
  }

  public static getToken(): string {
    return localStorage.getItem('token');
  }

  public static getRefreshToken(): string {
    return localStorage.getItem('refreshToken');
  }

  public static getDecodeToken(): Token{
    return TokenUtils.getDecodeToken(this.getToken());
  }

  public static clearStorage(): void {
    localStorage.clear();
  }

  public static saveWebVersion(version: string): void{
    localStorage.setItem('webVersion', version);
  }

  public static getWebVersion(): string{
    return localStorage.getItem('webVersion');
  }

  public static getServerVersion(){
    return this.getDecodeToken().webVersion;
  }
}
